import { Button } from '@cms/components/data/Button'
import { PreviewDraftIcon } from '@cms/components/icons'
import { useSnackbar } from '@cms/providers/SnackbarProvider'
import api from '@cms/utils/api'
import { useAppSelector } from '@cms/utils/store/hooks'
import { useMutation } from '@tanstack/react-query'
import { useMemo } from 'react'

export const PreviewDraftButton = () => {
    const { showSnackbar } = useSnackbar();
    const { story } = useAppSelector((state) => state.editor)

    const createPrivatePreviewMutation = useMutation({
        mutationFn: async () => {
            const res = await api.post<{ token: string }>(`/stories/${story?._id}/private-preview`)
            return res.data
        },
        onError(error) {
            showSnackbar('Error creating private preview link. ' + (error as Error).message || 'An error occurred', 'error');
        },
        onSuccess(data) {
            const previewUrl = `${import.meta.env.VITE_FRONTEND_BASE_URL}/preview?token=${data.token}`

            // // Option - 1
            // window.open(previewUrl, '_blank', 'noopener,noreferrer')

            // Option - 2
            const a = document.createElement('a')
            a.href = previewUrl
            a.target = '_blank'
            a.rel = 'noopener noreferrer'
            a.click()
            a.remove()
        }
    })

    const handlePreviewDraft = () => {
        createPrivatePreviewMutation.mutate()
    }

    const buttonState = useMemo(() => {
        if (!story?.saved_story_version || !story?._id) {
            return {
                type: 'disabled',
                tooltip: 'You need to save the story first to preview draft'
            }
        }

        return {
            type: 'enabled',
            tooltip: 'Preview draft story'
        }
    }, [story])

    return (
        <Button
            as='button'
            disabled={buttonState?.type === 'disabled'}
            shape='square'
            tooltip={buttonState?.tooltip}
            inputVariant='gray_text_white_bg'
            onClick={handlePreviewDraft}
        >
            <PreviewDraftIcon width="24" height="24" />
        </Button>
    )
}
